/*
 * Checks whether the html contains any text
 */
export const isEmptyHtml = (html: string): boolean => {
    if (typeof window === "undefined") return;

    if (html && document) {
        const tmp = document?.createElement("div");
        tmp.innerHTML = html;
        return !tmp.textContent && !tmp.innerText;
    }
    return true;
};

export default isEmptyHtml;
